import { OrderTextContainer } from "src/app/containers";
import { useIntl } from "react-intl";
import { SimpleEntityGrid } from "src/app/components/grid/SimpleEntityGrid";
import { KeywordsDTOSchema } from "src/app/types/keywords";
import { KeywordsTransport } from "src/app/transports/keywords";
import useKeywordsRanklvl3GridColumns from "./useKeywordsRanklvl3GridColumns";
import { getRowStyle } from "src/app/utils/aggrid/keywordRowColor";
import { KeywordMetricsModalContainer } from "src/app/components";

const VerifiedKeywordsRanklvl3Grid = () => {
    const { formatMessage } = useIntl();
    const gridColumns = useKeywordsRanklvl3GridColumns();

    return (
        <>
            <SimpleEntityGrid
                columns={gridColumns}
                actions={["disable", "orderText"]}
                getRowStyle={getRowStyle}
                toolbarButtonAction={{
                    add: false,
                    export: true,
                    active: true,
                    metrics: true,
                }}
                orderTextFormBodyContainer={OrderTextContainer}
                entityName={formatMessage({ id: "common.entity.keyword" })}
                metricsFormBodyContainer={KeywordMetricsModalContainer}
                listHandler={() =>
                    KeywordsTransport.list("ranklvl3", {
                        filterModel: {
                            verified: {
                                type: "equals",
                                filter: true,
                            },
                        },
                    })
                }
                formTransformer={KeywordsTransport.formTransformer}
                toggleActiveHandler={KeywordsTransport.toggleActive}
                saveHandler={KeywordsTransport.save}
                formBody={() => <></>}
                validationSchema={KeywordsDTOSchema}
            />
        </>
    );
};

export default VerifiedKeywordsRanklvl3Grid;
